import { GenIcon } from '../helpers/IconBase.es.js';

const BriefCaseOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: {
      fill: "#000000",
      version: "1.1",
      id: "Layer_1",
      viewBox: "0 0 492.313 492.313"
    },
    child: [
      {
        tag: "g",
        attr: {},
        child: [
          {
            tag: "g",
            attr: {},
            child: [
              {
                tag: "path",
                attr: {
                  d: "M352.005,107.714V78.56c0-21.721-17.663-39.385-39.385-39.385H179.692c-21.716,0-39.385,17.663-39.385,39.385v29.154H0\n			v345.423h492.313V107.714H352.005z M160,78.56c0-10.856,8.832-19.692,19.692-19.692H312.62c10.856,0,19.692,8.837,19.692,19.692\n			v29.154H160V78.56z M472.62,433.445H19.692V207.368l63.721,83.413c7.413,9.692,19.111,15.471,31.298,15.471h100.755v5.827\n			c0,16.923,13.764,30.683,30.688,30.683c16.918,0,30.688-13.76,30.688-30.683v-5.827h100.76c12.192,0,23.885-5.789,31.298-15.471\n			l63.721-83.413V433.445z M235.159,312.079v-34.462h21.99v34.462c0,6.058-4.933,10.99-10.995,10.99\n			S235.159,318.137,235.159,312.079z M472.62,174.915L393.245,278.82c-3.702,4.846-9.548,7.74-15.644,7.74h-100.76v-28.635h-61.375\n			v28.635H114.712c-6.096,0-11.947-2.894-15.649-7.74l-79.37-103.899v-47.514h120.615h211.697H472.62V174.915z"
                }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { BriefCaseOutlined };
